const pathPromisePairs = new Map<string, Promise<void>>();

/**
 * 指定されたパスから `.js` ファイルを読み込み、完了するまで待つ。
 * @remarks
 * 同一のパスで複数回呼ばれても1回しか読み込まれない。
 */
export const ensureScriptLoaded = (src: string): Promise<void> => {
  const promise = pathPromisePairs.get(src);
  if (promise) {
    return promise;
  }

  const newPromise = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.addEventListener('load', (event) => {
      resolve();
    });
    script.addEventListener('error', (event) => {
      reject(new Error(`Failed to load script: ${src}`));
    });
    document.head.appendChild(script);
  });

  pathPromisePairs.set(src, newPromise);
  return newPromise;
};
